import { useEffect, useState } from 'react';
import { Awareness } from 'y-protocols/awareness';

export interface CollaboratorInfo {
  clientId: number;
  userId: string;
  name: string;
  email?: string;
  color?: string;
  cursor?: { x: number; y: number };
  click?: { x: number; y: number; at: number };
}

/**
 * Hook to track active collaborators using Yjs awareness protocol
 */
export function useYjsAwareness(awareness: Awareness | null | undefined) {
  const [collaborators, setCollaborators] = useState<CollaboratorInfo[]>([]);

  useEffect(() => {
    if (!awareness) {
      setCollaborators([]);
      return;
    }

    const updateCollaborators = () => {
      const states = awareness.getStates();
      const collaboratorList: CollaboratorInfo[] = [];

      states.forEach((state, clientId) => {
        // Skip our own client
        if (clientId === awareness.clientID) return;

        if (state.user) {
          collaboratorList.push({
            clientId,
            userId: state.user.id,
            name: state.user.name,
            email: state.user.email,
            color: state.user.color,
            cursor: state.cursor,
            click: state.click,
          });
        }
      });

      setCollaborators(collaboratorList);
    };

    // Initial update
    updateCollaborators();

    // Listen for changes
    awareness.on('change', updateCollaborators);

    return () => {
      awareness.off('change', updateCollaborators);
    };
  }, [awareness]);

  return collaborators;
}
